<template>
    <div class="wrapper wrapper-content wrapper-boxed" v-if="quote">
        {{quote.name}}
        
    </div>
</template>

<script>
    
    import { mapState, mapActions } from 'vuex'

    export default {
        data: function () {
            return {
                
            }
        },
        computed: {
            ...mapState('quote', {
                quote: 'single'
            }),
        },
        
        mounted: function() {

            var that = this;

        },

        created: function() {
            this.getQuote(this.$route.params.quote_id);
        },

        watch: {

        },

        methods: {
            ...mapActions('quote', {getQuote: 'getSingle'})
        }
    }
</script>